import _styled4 from "styled-components";
import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
import React from 'react';
import EnergyLabel from '../energy-label/EnergyLabel';
import { boxStyle, contentStyle, performanceTitle } from './EnergyBlock.style';
export const EnergyBlock = _ref => {
  let {
    type,
    performance,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement("div", rest, /*#__PURE__*/React.createElement(_StyledDiv, null, /*#__PURE__*/React.createElement(_StyledDiv2, null, /*#__PURE__*/React.createElement(EnergyLabel, {
    type: type
  })), /*#__PURE__*/React.createElement(_StyledDiv3, null, /*#__PURE__*/React.createElement(_StyledH, null, "Indice prestazione energetica"), /*#__PURE__*/React.createElement("div", {
    "data-ref": "performance-value"
  }, performance, " kW h/m\xB2 anno"))));
};
export default EnergyBlock;
var _StyledDiv = _styled("div").withConfig({
  displayName: "EnergyBlock___StyledDiv",
  componentId: "sc-1p7buvb-0"
})(["", ""], contentStyle);
var _StyledDiv2 = _styled("div").withConfig({
  displayName: "EnergyBlock___StyledDiv2",
  componentId: "sc-1p7buvb-1"
})(["", ""], boxStyle);
var _StyledDiv3 = _styled("div").withConfig({
  displayName: "EnergyBlock___StyledDiv3",
  componentId: "sc-1p7buvb-2"
})(["", ""], boxStyle);
var _StyledH = _styled("h4").withConfig({
  displayName: "EnergyBlock___StyledH",
  componentId: "sc-1p7buvb-3"
})(["", ""], performanceTitle);
//# sourceMappingURL=EnergyBlock.js.map